import { z } from 'zod'

export const cutContainerRowSchema = z.object({
  bay: z.union([z.string(), z.number()]).optional(),
  container: z.string().optional(),
  id: z.union([z.number(), z.string()]).optional(),
  position: z.union([z.string(), z.number()]).optional(),
})

export const cutContainersSchema = z.array(cutContainerRowSchema)

const cargomateSchema = z.object({
  cutContainers: cutContainersSchema,
})

export default cargomateSchema
